import styled from 'styled-components';

export const SelectHeader = styled.p.attrs({
  className: 'px-2 py-1.5 text-xs font-semibold text-muted-foreground',
})``;

export const OptionRow = styled.div.attrs<{ $active?: boolean }>((props) => ({
  className: `flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-sm ${
    props.$active ? 'bg-accent text-accent-foreground' : 'text-foreground'
  }`,
}))<{ $active?: boolean }>``;

export const NoSelectionRow = styled.div.attrs<{ $active?: boolean }>((props) => ({
  className: `flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-sm ${
    props.$active ? 'bg-accent text-accent-foreground' : 'text-muted-foreground'
  }`,
}))<{ $active?: boolean }>``;

export const OptionMarker = styled.span.attrs({
  className: 'inline-flex h-5 w-5 items-center justify-center rounded bg-muted text-xs',
})``;

export const OptionLabel = styled.span.attrs({
  className: 'min-w-0 flex-1',
})``;

export const CommitButton = styled.button.attrs<{ $active?: boolean }>((props) => ({
  type: 'button',
  className: `mt-1 w-full cursor-pointer rounded bg-primary px-2 py-1.5 text-sm text-primary-foreground ${
    props.$active ? 'ring-2 ring-ring ring-offset-1' : ''
  }`,
}))<{ $active?: boolean }>``;
